export const STEP_NAME_START = "start";
export const STEP_NAME_QUESTIONNAIRE = "questionnaire";
export const STEP_NAME_PLAN = "plan";
export const STEP_NAME_DETAILS = "details";
export const STEP_NAME_PAY = "pay";

export const headerStepperData = [
  {
    key: STEP_NAME_START,
    title_en: "Start",
    title_ar: "ابدأ",
  },
  {
    key: STEP_NAME_QUESTIONNAIRE,
    title_en: "Questionnaire",
    title_ar: "استبيان",
  },
  {
    key: STEP_NAME_PLAN,
    title_en: "Plan",
    title_ar: "خطة",
  },
  {
    key: STEP_NAME_DETAILS,
    title_en: "Details",
    title_ar: "تفاصيل",
  },
  {
    key: STEP_NAME_PAY,
    title_en: "Pay",
    title_ar: "دفع",
  },
];
